
export default (context, inject) => {
  inject('webID', () => {
    const { query } = context.route
    const { store } = context

    if (query?.webid_status) {
      const status = query.webid_status
      const oldStatus = store.getters['webid/getStatus']
      if (oldStatus !== status) {
        localStorage.setItem('webid_status', status)
        store.dispatch('webid/setStatus', status)

        try {
          context.$api.user.sendWebIdResponse(status)
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Error sending webid response', e)
        }

        try {
          // eslint-disable-next-line no-undef
          clarity('set', 'webid', status)
        } catch (error) {
        }
      }
    }

    if (!query?.webid_status) {
      const status = localStorage.getItem('webid_status')
      if (status) {
        store.dispatch('webid/setStatus', status)
      }
    }

    /**
     * Needs Partner
     */

    if (query?.needs_w_partner) {
      const status = query.needs_w_partner
      const oldStatus = store.getters['webid/isPartner']
      if (oldStatus !== status) {
        localStorage.setItem('needs_w_partner', status)
        store.dispatch('webid/setPartner', status)

        try {
          // eslint-disable-next-line no-undef
          clarity('set', 'needs_w_partner', status)
        } catch (error) {
        }
      }
    }

    if (!query?.needs_w_partner) {
      const status = localStorage.getItem('needs_w_partner')
      if (status) {
        store.dispatch('webid/setPartner', status)
      }
    }

    /**
     * Partner Status
     */

    if (query?.partner_webid_status) {
      const status = query.partner_webid_status
      const oldStatus = store.getters['webid/partnerStatus']
      if (oldStatus !== status) {
        localStorage.setItem('w_partner_status', status)
        store.dispatch('webid/setPartnerStatus', status)

        try {
          // eslint-disable-next-line no-undef
          clarity('set', 'partnerStatus', status)
        } catch (error) {
        }
      }
    }

    if (!query?.partner_webid_status) {
      const status = localStorage.getItem('w_partner_status')
      if (status) {
        store.dispatch('webid/setPartnerStatus', status)
      }
    }
  })
}
